export enum TerminalPrintReceiptParamValues {
  NOT_PRINT = '0',
  PRINT_KIOSK_PRODUCTS_ONLY = '1',
  PRINT_ALWAYS = '2'
}
